// Teksty ekranów startowych z src/content/screens.json (logowanie, 3 powitania, 5 powitań na ekranie głównym, ekran po lekcji) i wybór wariantu.
// Każdy tekst to para { en, pl } (patch-33: interfejs idzie za przełącznikiem EN/PL); polskie teksty mogą mieć formy płci `{eś|aś}`.
import data from '../content/screens.json' with { type: 'json' };
import type { TeacherLang } from '../types.ts';
import type { Pose } from '../ui/kit.ts';
import type { Pair } from './i18n.ts';

export interface ScreenText {
  title: Pair;
  text: Pair;
  pose: Pose;
}

export type FinishedScreen = ScreenText & { titleNoName: Pair };

export const LOGIN_SCREEN = data.login as ScreenText;
export const WELCOME_SCREENS = data.welcome as ScreenText[];
export const HOME_SCREENS = data.home as ScreenText[];
export const FINISHED_SCREEN = data.finished as FinishedScreen;

/** Tytuł ekranu „po lekcji” z imieniem dziecka (bez imienia — wersja bez zwrotu) w podanym języku (domyślnie po polsku). */
export function finishedTitle(name: string, lang: TeacherLang = 'pl'): string {
  const n = name.trim();
  return n ? FINISHED_SCREEN.title[lang].replace('{name}', () => n) : FINISHED_SCREEN.titleNoName[lang];
}
